import { bubEvents } from 'shared/events/bub_events';

const DEFAULT_SHARE_TEXT = 'I found this on Chirp and thought you might like it!';

export class SocialSharing {
  constructor({
    urlOverride = null,
    omitSource = false,
    useReferralShortUrl = false,
    emailShareTextOverride = null,
    twitterShareTextOverride = null,
    pinterestShareTextOverride = null,
  } = {}) {
    this.url = new URL(urlOverride || window.location.href);
    this.omitSource = omitSource;
    this.useReferralShortUrl = useReferralShortUrl;
    this.emailShareText = emailShareTextOverride || DEFAULT_SHARE_TEXT;
    this.pinterestShareText = pinterestShareTextOverride || DEFAULT_SHARE_TEXT;
    this.twitterShareText = twitterShareTextOverride || DEFAULT_SHARE_TEXT;

    if (!urlOverride && document.querySelector('link[rel=canonical]')) {
      this.canonicalUrlString = document.querySelector('link[rel=canonical]').href;
    }
  }

  static trackClick(label) {
    bubEvents.track('Sharing Component', 'Clicked button', _.merge({ label }));
  }

  static generateUtmSource(platform, pageSlug) {
    return `utm_source=${platform}&utm_campaign=${pageSlug}&utm_medium=sharing&utm_id=unpaid_${platform}_on_page_share`;
  }

  static generateSource(platform) {
    return `source=unpaid_${platform}_on_page_share`;
  }

  getPageSlug() {
    const currentUrl = this.url.pathname;
    return currentUrl.substring(currentUrl.lastIndexOf('/') + 1);
  }

  generateEmailBody() {
    const utm = escape(SocialSharing.generateUtmSource('email', this.getPageSlug()));
    const source = SocialSharing.generateSource('email');

    let emailLink;
    if (this.omitSource) {
      emailLink = `${this.url.href}?${utm}`;
    } else {
      emailLink = `${this.url.href}?${utm}%26${source}`;
    }

    return `${this.emailShareText}%0D%0A%0D%0A${emailLink}`;
  }

  generateShareUrl(provider) {
    const utm = SocialSharing.generateUtmSource(provider, this.getPageSlug());
    const source = SocialSharing.generateSource(provider);
    const url = this.canonicalUrlString || this.url;

    if (this.useReferralShortUrl) {
      return `${url}/${provider}`;
    }

    if (this.omitSource) {
      return `${url}?${utm}`;
    }

    return `${url}?${source}&${utm}`;
  }

  shareFacebook() {
    window.FB.ui({
      method: 'share',
      href: this.generateShareUrl('facebook'),
    });
  }

  sharePinterest(shareImageUrl) {
    const text = encodeURIComponent(this.pinterestShareText);
    const shareUrl = escape(this.generateShareUrl('pinterest'));
    window.open(
      `//www.pinterest.com/pin/create/button/?url=${shareUrl}&media=${shareImageUrl}&description=${text}`,
      '',
      'width=750,height=288',
    );
  }

  shareTwitter() {
    const text = encodeURIComponent(this.twitterShareText);
    const shareUrlParam = escape(this.generateShareUrl('twitter'));
    const twitterShareUrl = `https://twitter.com/intent/tweet?text=${text}&original_referer=${window.location.href}&url=${shareUrlParam}&via=ChirpBooks`;
    window.open(twitterShareUrl, '', 'width=550,height=520');
  }
}
